module.exports = __webpack_public_path__ + "src/assets/font/GooseberryJuice.woff";